<div id="loading" [class.hide]="hide" [class.compact]="hideText" class="loading-container" role="status" aria-live="polite">
  <div class="sv-spinner-wrapper" [style.width.px]="width" [style.height.px]="width">
    <!-- Anel de Gradiente Rotativo Subtil (Apenas as Cores do Site) -->
    <svg class="sv-spinner-svg" viewBox="0 0 50 50">
      <defs>
        <linearGradient id="svSpinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="var(--color-dark-blue, #1b1464)" />
          <stop offset="60%" stop-color="var(--color-teal, #0d7d55)" />
          <stop offset="100%" stop-color="var(--color-teal, #0d7d55)" />
        </linearGradient>
      </defs>
      <!-- Arco Ativo Rotativo com Cores do Site (Sem pista cinzenta de fundo) -->
      <circle
        class="sv-spinner-arc"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="url(#svSpinnerGradient)"
        stroke-width="2.5"
        stroke-dasharray="75 55"
        stroke-linecap="round"
      />
    </svg>

    <!-- Logótipo da Seguros Virtual no Centro (Cápsula Oca idêntica ao Logótipo Oficial da marca) -->
    <div class="sv-spinner-center">
      <svg class="sv-center-icon-svg" viewBox="0 0 36 20">
        <rect x="3.5" y="3.5" width="29" height="13" rx="6.5" ry="6.5" fill="none" stroke="currentColor" stroke-width="3.8" />
      </svg>
    </div>
  </div>

  <ng-container *ngIf="!hideText && width >= 40">
    <div class="sv-loading-text">
      <span>{{ text || ('COMMON.LOADING.DATA' | translate) }}</span>
      <span class="loading-dots">
        <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
      </span>
    </div>
  </ng-container>
</div>
